import {combineReducers} from "redux";
import loginReducer from "./auth/loginReducer";
import liveStatusChangeReducer from "./auth/liveStatusChangeReducer";
import InstructorLiveListReducer from "./Instructor/InstructorLiveListReducer";
import oneToOneReducer from "./Instructor/oneToOneReducer";
import oneToManyReducer from "./Instructor/oneToManyReducer";


export default combineReducers({
    login: loginReducer,
    InstructorLiveList: InstructorLiveListReducer,
    liveStatusChange: liveStatusChangeReducer,
    oneToOneReducer: oneToOneReducer,
    oneToManyReducer: oneToManyReducer,
});